import React, {PureComponent} from "react";
import {withChatContext} from "stream-chat-react";
import User from "./User";

import {userList, searchWrapper, searchInput, refresh} from '../styles/general.module.scss';
import {name} from '../styles/user.module.scss';

import {userRoles, helpRoles, qaRoles} from '../local_roles';

class Users extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            filter: '',
            allUsers: [],
            pullingUsers: false
        };

        this.delayTimer = null;
    }

    componentDidMount() {
        const {client, childRef} = this.props;

        childRef(this);

        client.on('user.presence.changed', this.userPresenceEventHandler);
        client.on('channel.deleted', this.channelDeletedEventHandler);
    }

    componentWillUnmount() {
        const {client, childRef} = this.props;

        childRef(undefined);

        client.off(this.userPresenceEventHandler);
        client.off(this.channelDeletedEventHandler);
    }

    userPresenceEventHandler = (e) => {
        console.log('status changed' ,e);
        this.forceUpdate();
    };

    channelDeletedEventHandler = async (e) => {
        console.log('channel deleted', e);
        this.forceUpdate();
    };

    startConversation = async (partnerId) => {
        const {client, user, setActiveChannel} = this.props;
        const isHelpUser = helpRoles.includes(user.local_role);
        const isQAUser = qaRoles.includes(user.local_role);

        if (isHelpUser) { // show help channel
            const filter = { type: 'messaging', id: { $eq: `${partnerId}-help` } };
            const foundChannels = await client.queryChannels(filter, {}, {});

            if (foundChannels.length > 0) {
                setActiveChannel(foundChannels[0]);
            } else {
                const helpUsers = await client.queryUsers(
                    { local_role: {$in : helpRoles} },
                );
                const channelUsers = helpUsers.users.map(u => u.id);
                channelUsers.push(partnerId);

                const channel = client.channel("messaging", `${partnerId}-help`, {
                    name: `${partnerId}-help`,
                    members: channelUsers
                });

                const response = await channel.create();
                await channel.watch();
                await channel.show();
                setActiveChannel(channel);
            }
        } else if (isQAUser) { // show qa channel
            const filter = { type: 'messaging', id: { $eq: `${partnerId}-qa` } };
            const foundChannels = await client.queryChannels(filter, {}, {});

            if (foundChannels.length > 0) {
                setActiveChannel(foundChannels[0]);
            } else {
                const qaUsers = await client.queryUsers(
                    { local_role: {$in : qaRoles} },
                );
                const channelUsers = qaUsers.users.map(u => u.id);
                channelUsers.push(partnerId);

                const channel = client.channel("messaging", `${partnerId}-qa`, {
                    name: `${partnerId}-qa`,
                    members: channelUsers
                });

                const response = await channel.create();
                await channel.watch();
                await channel.show();
                setActiveChannel(channel);
            }
        } else { // create 1 to 1 channel
            const filter = { type: 'messaging', id: { $in: [`${user.id}-${partnerId}`,`${partnerId}-${user.id}`] } };
            const foundChannels = await client.queryChannels(filter, {}, {});

            if (foundChannels.length > 0) {
                setActiveChannel(foundChannels[0]);
            } else {
                const channel = client.channel("messaging", `${user.id}-${partnerId}`, {
                    name: `${user.id}-${partnerId}`,
                    members: [user.id, partnerId]
                });
                const response = await channel.create();
                await channel.watch();
                await channel.show();
                setActiveChannel(channel);
            }
        }
    };

    onSearchChange = async (ev) => {
        const {value} = ev.target;
        clearTimeout(this.delayTimer);
        this.setState({filter: value});

        if (!value) return;

        this.delayTimer = setTimeout(this.searchUser.bind(null, value), 500);
    };

    searchUser = async (term) => {
        const {client} = this.props;

        const {users} = await client.queryUsers(
            { local_role: {$in : userRoles}, name: { $autocomplete: term.toLowerCase() } },
            { name: 1},
            { presence: true},
        );

        this.setState({allUsers: users})
    };

    sortUsers = (a, b) => {
        if ( a.name < b.name ) return -1;
        if ( a.name > b.name ) return 1;
        return 0;
    };

    pullUsers = async (ev) => {
        const {client} = this.props;
        const offset = Object.values(client.state.users).length;

        this.setState({pullingUsers: true});
        await this.props.pullUsers(offset);
        this.setState({pullingUsers: false});
    };

    startOneToOneChat = (partnerId) => {
        this.startConversation(partnerId)
    }

    render () {
        const {client, user} = this.props;
        const {filter, allUsers, pullingUsers} = this.state;
        const clientUsers = Object.values(client.state.users);

        const users = filter ? allUsers : clientUsers.filter(u => u.online && u.id !== user.id && userRoles.includes(u.local_role));
        users.sort(this.sortUsers);

        return (
            <div>
                <div className={searchWrapper}>
                    <input className={searchInput} onChange={this.onSearchChange} placeholder="Filter users"/>
                </div>
                <div className={`list-group ${userList}`}>
                    {users.filter(u => u.name).map(user => {
                        return (
                            <button
                                onClick={() => this.startConversation(user.id)}
                                key={user.id}
                                type="button"
                                className="list-group-item list-group-item-action"
                            >
                                <User user={user}>
                                    <div className={name}>{user.name}</div>
                                </User>
                            </button>
                        )}
                    )}
                </div>
                {users.length < 6 && !filter &&
                    <div className={refresh}>
                        <button className="btn btn-default" disabled={pullingUsers} onClick={this.pullUsers}>Refresh
                        </button>
                    </div>
                }
            </div>
        );
    }
};

export default withChatContext(Users);
